import { createContext, useContext } from 'react';

import type { PostTheme, UTMAttrs } from '@/types';

export interface IPostContentContext {
  utmParams?: UTMAttrs;
  postTheme?: PostTheme;
}

export const PostContentContext = createContext<IPostContentContext>({});

export function usePostContentContext() {
  const context = useContext(PostContentContext);

  if (!context) {
    throw new Error('usePostContentContext must be used within a PostContent');
  }

  return context;
}
